<template>
  <div class="trade-order-block">
    <div class="block-content">
      <el-row class="content-row">
        <template v-if="tradeApplyInfoVO.trCode">
          <el-col :span="3">使用的TRcode</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.trCode }}</el-col>
        </template>
        <el-col :span="3">已选择MMR12</el-col>
        <el-col :span="9">{{ tradeApplyInfoVO.mmr12 }}</el-col>
      </el-row>
      <el-row class="content-row">
        <template v-if="tradeApplyInfoVO.companyEntityCode">
          <el-col :span="3">已选择所属工厂</el-col>
          <el-col :span="9">
            <template v-if="tradeApplyInfoVO.costCenterCode">{{ tradeApplyInfoVO.companyEntityCode }}</template>
          </el-col>
        </template>
        <template v-if="tradeApplyInfoVO.companyEntityCode">
          <el-col :span="3">已选择成本中心</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.costCenterCode }}</el-col>
        </template>
      </el-row>
      <el-row class="content-row">
        <template v-if="!tradeApplyInfoVO.companyEntityCode">
          <el-col :span="3">已选择成本中心</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.costCenterCode }}</el-col>
        </template>
        <el-col :span="3">已选择总账科目</el-col>
        <el-col :span="9">{{ tradeApplyInfoVO.ledgerAccount }}</el-col>
        <template v-if="tradeApplyInfoVO.budgetMonth">
          <el-col :span="3">已选择业务月份</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.budgetMonth }}</el-col>
        </template>
      </el-row>
      <el-row class="content-row">
        <template v-if="purchaseOrderReceiveVO.poNumber">
          <el-col :span="3">收货信息</el-col>
          <el-col :span="9" >
            <template v-if="purchaseOrderReceiveVO.poStatus !== 2">
              {{ purchaseOrderReceiveVO.orderReceiveStatusName  }},已收货金额{{ actualAmount || 0 | thousandSymbol }}元
            <span class="base-red" @click="handleIcircle">查看收货详情>></span>
            </template>
              <span  class="color-gray" v-else>历史订单请在SAP中查看收货信息</span> 
          </el-col>
        </template>
      </el-row>
    </div>
  </div>
</template>

<script>
import { localStorageUtils } from '@/utils/localstorage'
import tradeApi from '@/api/trade'
const math = require('mathjs')
export default {
  name: 'order-quota-Info',
  components: {},
  props: {
    tradeApplyInfoVO: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading:false,
      purchaseOrderReceiveVO:{},
      receiveOrderDetailList:[]
    }
  },
  watch:{
    tradeApplyInfoVO: {
      immediate: true,
      deep:true,
      handler: function(newValue, oldValue) {
        if (newValue && this.canViewRecevice) {
          this.getReceiveOrderInfo()
        }
      }
    }
  },
  computed: {
    canViewRecevice() {
      const acceptanceStatus = Number(this.tradeApplyInfoVO.acceptanceStatus)
      return acceptanceStatus >= 450
    },
    // 已收货金额
    actualAmount(){
      const poReceivedAmount = math.bignumber(this.purchaseOrderReceiveVO.poReceivedAmount || 0)
      const poReversedAmount = math.bignumber(this.purchaseOrderReceiveVO.poReversedAmount || 0)
      return math.number( math.subtract(poReceivedAmount,poReversedAmount))
    },
  },
  methods: {
     // 订单收货详情
     getReceiveOrderInfo() {
      this.loading = true
      tradeApi.getReceiveOrderInfo({ orderId: this.tradeApplyInfoVO.orderId }).then(res => {
        if (res.data.resultCode === '0') {
          const { purchaseOrderReceiveVO } = res.data.resultData
          this.purchaseOrderReceiveVO = purchaseOrderReceiveVO || {}
          this.receiveOrderDetailList = this.purchaseOrderReceiveVO.receiveOrderDetailList || []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleIcircle(){
      const inUse = ['prod', 'test', 'dev'].includes(process.env.VUE_APP_ENV)
      if (!inUse) {
        return this.$notify({
          title: '提示',
          message: '暂未开放，敬请期待',
          type: 'warning',
        })
      }
      const token = localStorageUtils.get('eb-token')
      const urlMap = {
        dev: 'https://icircle-dev.abipocm.com/login-auto',
        test: 'https://icircle-test.abipocm.com/login-auto',
        prod: 'https://icircle.abipocm.com/login-auto'
      }
      let url = urlMap[process.env.VUE_APP_ENV]
      if (!url) {
        return
      }
      if(!this.tradeApplyInfoVO.orderId){
        this.$message.error('缺少orderId')
        return 
      }
      const targetUri = `/order/info?orderId=${this.tradeApplyInfoVO.orderId}`
      window.open(`${url}?token=${token}&targetUri=${targetUri}`, '_blank')
    }
  },
}
</script>
<style lang='scss' scoped>
.base-red{
  padding-left: 10px;
  color:$base-red;
  cursor: pointer;
}
.color-gray{
  color:$base-grey4;
}
</style>